import { Component, OnInit } from '@angular/core';
import { Food } from 'src/app/model/Food';

@Component({
  selector: 'app-food-results',
  templateUrl: './food-results.component.html',
  styleUrls: ['./food-results.component.css']
})
export class FoodResultsComponent implements OnInit {
  foodNames : string[];

  constructor() { }

  ngOnInit() {
  }

  public setFoods(foods: Food[]) {
    foods.forEach(f => {
      this.foodNames.push(f.name);
    });
  }

}
